import { useMemo, useContext } from "react";
import { AppContext } from "../contexts";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

function useDateTime() {
  const { is24hrTime, dateTimeFormat } = useContext(AppContext);

  const calculateFinalFormat = (is24HoursFormat, formatType) => {
    const dateMonthYearFormats = [
      "YYYY",
      "YY",
      "MMMM",
      "MMM",
      "MM",
      "M",
      "DD",
      "D",
      "dd",
      "d",
      "yyyy",
      "yy",
    ];
    let filteredFormat = formatType;
    const containsFormat = dateMonthYearFormats.some((format) =>
      filteredFormat.includes(format)
    );
    if (containsFormat) {
      filteredFormat = filteredFormat.split(" ")[1];
    }
    if (!Boolean(is24HoursFormat)) {
        filteredFormat = (filteredFormat.endsWith("A") || filteredFormat.endsWith("a"))
          ? filteredFormat.replace("A", "")
          : `${filteredFormat} A`;
        filteredFormat = filteredFormat.replaceAll("H", "h");
      } else {
        filteredFormat = filteredFormat.replace("A", "");
        filteredFormat = filteredFormat.replaceAll("h", "H");
      }
    return filteredFormat;
  };

  const calculateDateFormat = (dateTimeFormat) => {
    let filteredDate = dateTimeFormat.split(" ")[0];
    filteredDate = filteredDate.replaceAll("y", "Y");
    filteredDate = filteredDate.replaceAll("d", "D");
    return filteredDate;
  }

  const formattedTime = useMemo(() => {
    return calculateFinalFormat(is24hrTime, dateTimeFormat);
  }, [is24hrTime, dateTimeFormat]);

  const formattedDate = useMemo(()=>{
        return calculateDateFormat(dateTimeFormat);
  },[dateTimeFormat]);

  const formatTime = (timeValue) => {
    return dayjs(timeValue).tz(dayjs.tz.guess()).format(formattedTime);
  };

  // Backend timestamps are UTC, with or without a trailing Z
  const toLocal = (value) => dayjs.utc(value).tz(dayjs.tz.guess());

  const formatDate = (value) => {
    if (!value || !dayjs.utc(value).isValid()) return value;
    return toLocal(value).format(formattedDate);
  };

  const formatDateTime = (value) => {
    if (!value || !dayjs.utc(value).isValid()) return value;
    return toLocal(value).format(`${formattedDate} ${formattedTime}`);
  };

  return {
    formatTime,
    formatDate,
    formatDateTime,
    formattedTime,
    formattedDate
  };
}

export default useDateTime;